<router-outlet></router-outlet>

<!--<a routerLink="/ui-page" class="__ui">UI</a>-->
